/* eslint-disable arrow-body-style */
import React, { useEffect, useMemo } from 'react';
import SegmentMetricsComponent from './SegmentMetricsComponent';
import { useLocal } from '@/pages/dashboard/utils/customHook';
import { useMetrics } from '../_config/utils';
import { getExplainVal } from '@/pages/dashboard/utils/getExplainVal';
import { connect, getLocale } from 'umi';
import { Bubble } from 'tea-component';

interface Props {
  value?: string;
  onChange?: (metrics) => void;
  explainInfo: any;
}

const SegmentMetrics = (props: Props) => {
  const {
    value,
    onChange,
    explainInfo
  } = props;
  const { options } = useMetrics();
  const { locale } = useLocal();

  const handleChange = (value:string) => {
    const metrics = options?.filter(item => item?.value === value)?.[0];
    onChange?.(metrics);
  };

  useEffect(() => {
    handleChange(value);
  }, [locale]);

  const segmentList = useMemo(() => {
    return options?.map((item) => {
      const explain = getExplainVal(explainInfo, item?.rainbowKey, getLocale());
      return {
        text:
          <Bubble
            content={
              explain ? <p className="db-SwitchChart__titleBubble-infoTxt" dangerouslySetInnerHTML={{ __html: explain?.replaceAll('\\n', '<br/>') }} /> : ''
            }
            dark
            className="metrics-segment__item-bubble"
            placement="top-start"
          >
            {item?.text}
          </Bubble>,
        // 转为字符串，实现选中效果
        value: item?.value,
      };
    }) || [];
  }, [options]);
	
  return (
    <SegmentMetricsComponent
      value={value}
      options={segmentList}
      onChange={handleChange}
    />
  );
};

export default connect((state: any) => {
  return {
    explainInfo: state.dashboard?.explainInfo,
  };
})(SegmentMetrics);